/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_60_SInputs */

const en_funnel_ob_daily_60_s = /** @type {(inputs: Funnel_Ob_Daily_60_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power reader, crush your list`)
};

const es_funnel_ob_daily_60_s = /** @type {(inputs: Funnel_Ob_Daily_60_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lector experto: acaba con tu lista`)
};

/**
* | output |
* | --- |
* | "Power reader, crush your list" |
*
* @param {Funnel_Ob_Daily_60_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_60_s = /** @type {((inputs?: Funnel_Ob_Daily_60_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_60_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_60_s(inputs)
	return en_funnel_ob_daily_60_s(inputs)
});